import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Globals } from '../objects/Globals';
import { Observable } from 'rxjs';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class InputComboService {

  private serviceUrl:string;
  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { this.serviceUrl = this.env.servicePath }

  createInputComboCard(type:string){
    var path = this.serviceUrl +"CreateInputComboCard/"+type;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  getInputComboList(id:string, inputFilter: string = ""):Observable<string>{
    var path = this.serviceUrl +"GetInputComboList/"+ id + "?inputFilter=" + inputFilter;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

}
